import getMaxFavoriteSuggestionCounts from './getMaxFavoriteSuggestionCounts';
import { favoritesStore } from 'owa-favorites';
import searchCache from 'owa-recipient-cache/lib/selectors/searchCache';
export default function getFavoritePeopleSuggestions(findText) {
    var existingFavoritePeople = [];
    favoritesStore.favoritesPersonaNodes.forEach(function (personaNode) {
        existingFavoritePeople.push.apply(existingFavoritePeople, personaNode.allEmailAddresses.map(function (emailAddress) { return ({
            EmailAddress: {
                EmailAddress: emailAddress,
            },
        }); }));
    });
    var maxPeopleSuggestions = getMaxFavoriteSuggestionCounts().people;
    var topRecipients = searchCache(findText, maxPeopleSuggestions /* numberOfResults */, existingFavoritePeople /* recipientsToExclude */, ['PrivateDL', 'PublicDL', 'GroupMailbox'] /* mailboxTypesToExclude */);
    return topRecipients.map(function (recipient) {
        return {
            data: recipient,
            id: recipient.PersonaId.Id,
            type: 1 /* Persona */,
            relevance: 0 /* Relevance scores will be supplied by providers in the future */,
        };
    });
}
//# sourceMappingURL=getFavoritePeopleSuggestions.js.map